import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_SURPRISE } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Surprise',
        name: 'Surprise',
        icon: 'fas fa-mortar-pestle'
    },
    {
        parent: 'Multiplayer.Surprise',
        key: 'Category',
        name: 'Category',
        icon: 'fas fa-list-alt',
        route: { name: ROUTE_NAME_SURPRISE.CATEGORY.INDEX }
    },
    {
        parent: 'Multiplayer.Surprise',
        key: 'Setting',
        name: 'Setting',
        icon: 'fas fa-cog',
        route: { name: ROUTE_NAME_SURPRISE.SETTING }
    }
]);

export default registerRouteForModule(router);
